import script from "./mainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./mainLayout.vue?vue&type=script&setup=true&lang=js"

import "./mainLayout.vue?vue&type=style&index=0&id=14b457d3&lang=css"

const __exports__ = script;

export default __exports__